<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="part" id="pt01">
<h1 class="pn"><a class="page" id="p19"></a><a class="xref" href="#/chirapp0008#toc"><span class="sm">PART</span> <span class="sm">ONE</span></a></h1>
<h1 class="pt"><a class="page" data-locator="p19"></a>Boys to Men</h1>
<div class="epigraph">
<p class="epf"><a class="page" data-locator="p19"></a>We need only realise our parents, remember our grandparents and know ourselves and our history is complete.</p>
<p class="ept"><span class="sm">GERTRUDE</span> <span class="sm">STEIN,</span> <i>The Making of Americans</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-rapp-0012.vue?4b732bca